var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-column ai-c jc-s gap-10"},[_c('img',{staticClass:"img-size-16",attrs:{"src":_vm.batteryImgSrc,"alt":"battery"}}),_c('img',{staticClass:"img-size-24",attrs:{"src":_vm.connImgSrc,"alt":"conn"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }